"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNUP17 = exports.isTituloEleitor = exports.isRenavam = exports.isPostalCode = exports.isPIS = exports.isJudicialProcess = exports.isCPF = exports.isCNPJ = exports.isCNH = void 0;
const cnh_1 = require("./cnh");
const cnpj_1 = require("./cnpj");
const cpf_1 = require("./cpf");
const judicialProcess_1 = require("./judicialProcess");
const nup17_1 = require("./nup17");
const pisPasep_1 = require("./pisPasep");
const postalCode_1 = require("./postalCode");
const renavam_1 = require("./renavam");
const tituloEleitor_1 = require("./tituloEleitor");
const isCNH = (value) => (0, cnh_1.validate)(value);
exports.isCNH = isCNH;
const isCNPJ = (value) => (0, cnpj_1.validate)(value);
exports.isCNPJ = isCNPJ;
const isCPF = (value) => (0, cpf_1.validate)(value);
exports.isCPF = isCPF;
const isJudicialProcess = (value) => (0, judicialProcess_1.validate)(value);
exports.isJudicialProcess = isJudicialProcess;
const isPIS = (value) => (0, pisPasep_1.validate)(value);
exports.isPIS = isPIS;
const isPostalCode = (value) => (0, postalCode_1.validate)(value);
exports.isPostalCode = isPostalCode;
const isRenavam = (value) => (0, renavam_1.validate)(value);
exports.isRenavam = isRenavam;
const isTituloEleitor = (value) => (0, tituloEleitor_1.validate)(value);
exports.isTituloEleitor = isTituloEleitor;
const isNUP17 = (value) => (0, nup17_1.validate)(value);
exports.isNUP17 = isNUP17;
exports.default = {
    isCNH: exports.isCNH,
    isCNPJ: exports.isCNPJ,
    isCPF: exports.isCPF,
    isJudicialProcess: exports.isJudicialProcess,
    isPIS: exports.isPIS,
    isPostalCode: exports.isPostalCode,
    isRenavam: exports.isRenavam,
    isTituloEleitor: exports.isTituloEleitor,
    isNUP17: exports.isNUP17,
};
//# sourceMappingURL=index.js.map